import { render, staticRenderFns } from "./ClaimApproval.vue?vue&type=template&id=6398d8ec&scoped=true"
import script from "./ClaimApproval.vue?vue&type=script&lang=js"
export * from "./ClaimApproval.vue?vue&type=script&lang=js"
import style0 from "./ClaimApproval.vue?vue&type=style&index=0&id=6398d8ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6398d8ec",
  null
  
)

export default component.exports